import { GAPS, SIZES } from '../constants';
import { DrawArea, NotificationConfig } from '../types';
import { drawAction } from './action-drawer';
import { drawIcons } from './icon-drawer';
import { drawSeparator } from './separator-drawer';
import { drawText } from './text-drawer';

/**
 * Рисует содержимое одной нотификации (иконки + текст + действия).
 */
export function drawNotificationContent(
    ctx: CanvasRenderingContext2D,
    area: DrawArea,
    config: NotificationConfig
): void {
    let x = area.x + SIZES.containerPaddingX;
    const y = area.y + area.height / 2; // центр по вертикали

    // 1. Иконки
    const iconsWidth = drawIcons(ctx, x, y, config.icons);
    if (iconsWidth > 0) {
        x += iconsWidth + GAPS.afterIcons;
    }

    // 2. Текст
    const textWidth = drawText(ctx, x, y, config.text);
    x += textWidth;

    // 3. Действия (если есть)
    if (config.actions && config.actions.length > 0) {
        x += GAPS.afterText;

        for (let i = 0; i < config.actions.length; i++) {
            // Разделитель перед действием (кроме первого)
            if (i > 0) {
                const separatorWidth = drawSeparator(ctx, x, y);
                x += separatorWidth;
            }

            const actionWidth = drawAction(ctx, x, y, config.actions[i]);
            x += actionWidth;
        }
    }
}

/**
 * Рисует содержимое объединённой нотификации (для secondary row).
 * Каждый элемент отделяется разделителем.
 */
export function drawCombinedContent(
    ctx: CanvasRenderingContext2D,
    area: DrawArea,
    configs: NotificationConfig[]
): void {
    let x = area.x + SIZES.containerPaddingX;
    const y = area.y + area.height / 2;

    for (let i = 0; i < configs.length; i++) {
        const config = configs[i];

        // Разделитель перед элементом (кроме первого)
        if (i > 0) {
            const separatorWidth = drawSeparator(ctx, x, y);
            x += separatorWidth;
        }

        // Иконки
        const iconsWidth = drawIcons(ctx, x, y, config.icons);
        if (iconsWidth > 0) {
            x += iconsWidth + GAPS.afterIcons;
        }

        // Текст
        const textWidth = drawText(ctx, x, y, config.text);
        x += textWidth;
    }
}
